import { useFirestore } from '../../hooks/useFirestore'

import '../reload/Reload.css'

export default function Reloadnew({ transactions }) {
  const { updateDocument } = useFirestore('transactions')

  const reload1 = () => {

    // console.log('transactions:', transactions)
    if (transactions) {
      transactions.forEach((doc) => {
      if (doc.rl2) {
        updateDocument(doc.id, { rl2: false })
        }
      })
    }
  }

  return (
    <div>
      <button className="btnReload" onClick={reload1}>Reload Common Items</button>
    </div>
  )
}
